////////////////////////////////////////////////subnav
if (!customElements.get("dl-js-subnav")) {
  class DL_Subnav extends HTMLElement {
    constructor() {
      super();
      const object = this;
      // console.log(this);
      object.wrap = object.closest(".dl-common_subnav");
      object.init();
      object.onScrollHandler = object.onScroll.bind(object);

      this.checkScroll = this.checkScroll.bind(this);
      window.addEventListener("scroll", object.onScrollHandler, false);
      window.addEventListener("resize", object.onResize.bind(object));
    }

    init() {
      const object = this;
      object.scrollAfter = 0;
      // console.log(object.getBoundingClientRect())
      // object.areaHeight = object.area.offsetHeight;
      // object.areaWidth = object.area.offsetWidth;
      // object.areaTop = DL_offsetTop(object.area);
      // object.areaLeft = DL_offsetLeft(object.area);
      // object.areaBottom = object.areaHeight + object.areaTop;
      // object.areaAdjust = 0;
      // object.overFlg = false;
      // if (window.innerHeight < object.areaTop + object.offsetHeight + object.areaAdjust * 2) {
      //   object.overFlg = true;
      // }
      object.onScroll();
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const object = this;
      var headerHeight = document.querySelector(".dl-header").offsetHeight;
      var position, top, left, bottom, width, transform;
      if (scrollTop - object.scrollAfter > 0) {
        // console.log("下にスクロール");
        DL_removeClass(object.wrap, "is-open");
      } else {
        // console.log("うえにスクロール");
        DL_addClass(object.wrap, "is-open");
      }
      object.scrollAfter = scrollTop;
      this.checkScroll();
      // top = headerHeight + "px";
      // object.wrap.style.transform = transform;
    }
    onResize() {
      const object = this;
      object.init();
      this.checkScroll();
    }

    checkScroll() {
      if (window.scrollY === 0) {
        this.wrap.classList.add("is-top");
      } else {
        this.wrap.classList.remove("is-top");
      }
    }
  }
  customElements.define("dl-js-subnav", DL_Subnav);
}
